module.exports = __webpack_public_path__ + "media/images/image-4-fd8e842e.jpg";